export default __webpack_public_path__ + "static/media/loading.765b4b6a.svg";